import Constants from 'expo-constants';
import { Platform } from 'react-native';
import { api } from '../services/api';
import { createGoogleAuthFlow } from './googleAuthFlow';
import { requestGoogleCredential } from './googleCredential';

export const googleSignInEnabled = () =>
  (Platform.OS === 'ios' || Platform.OS === 'android')
  && Constants.expoConfig?.extra?.googleSignInEnabled === true;

export const googleAuth = createGoogleAuthFlow(api, requestGoogleCredential);
